import { useMediaQuery } from 'react-responsive';

const useIsMobile = () =>
  useMediaQuery({
    query: '(max-width: 767px)',
  });

export default useIsMobile;
